/**
 * Carte d'état de traitement IA — design Carbon épuré
 */

import { Tile, Button } from '@carbon/react';
import {
  WarningAltFilled,
  CheckmarkFilled,
  MachineLearning,
} from '@carbon/icons-react';
import styles from './AIProcessingCard.module.scss';

interface AIProcessingCardProps {
  isLoading: boolean;
  error: string | null;
  success?: boolean;
  title: string;
  description?: string;
  onRetry?: () => void;
  children?: React.ReactNode;
  className?: string;
}

export function AIProcessingCard({
  isLoading,
  error,
  success = false,
  title,
  description,
  onRetry,
  children,
  className = '',
}: AIProcessingCardProps) {
  return (
    <div className={`${styles.card} ${className}`}>
      <Tile className={styles.tile}>
        <div className={styles.content}>
          <div className={styles.main}>
            <div
              className={`${styles.iconWrap} ${error ? styles.iconWrapError : ''}`}
            >
              {isLoading && <div className={styles.spinner} />}
              {error && (
                <WarningAltFilled size={24} className={styles.iconError} />
              )}
              {success && (
                <CheckmarkFilled size={24} className={styles.iconSuccess} />
              )}
              {!isLoading && !error && !success && (
                <MachineLearning size={24} className={styles.iconIdle} />
              )}
            </div>
            <div className={styles.text}>
              <h3 className={styles.title}>{title}</h3>
              {description && (
                <p className={styles.description}>{description}</p>
              )}
            </div>
          </div>

          {isLoading && (
            <div className={styles.progress}>
              <div className={styles.progressBar}>
                <div className={styles.progressFill} />
              </div>
            </div>
          )}

          {error && (
            <div className={styles.errorBox}>
              <p className={styles.errorText}>{error}</p>
              {onRetry && (
                <Button
                  kind="tertiary"
                  size="sm"
                  onClick={onRetry}
                  className={styles.retryBtn}
                >
                  Réessayer
                </Button>
              )}
            </div>
          )}
        </div>
      </Tile>
      {children && <div className={styles.extra}>{children}</div>}
    </div>
  );
}
